function Anticonceptietool(el) {
    this.el = el;
    this.filtersEl = this.el.querySelector('.jsActiconceptieFilters');
    this.activeChoices = [];
    this.gridEl = this.el.querySelector('.jsAnticonceptietoolMethodeGrid');
    this.methodEls = this.el.querySelectorAll('.jsAnticonceptietoolMethodeGrid .jsTool');
    this.methododsAvailableEl = this.el.querySelector('.jsAnticonceptietoolItemsAvailable');
    this.noItemsEl = this.el.querySelector('.jsAnticonceptietoolNoItems');

    this.el.querySelector('.jsAnticonceptieToolResetBtn').addEventListener('click', e => {
        e.preventDefault();
        this.reset();
    });

    this.el.addEventListener('click', e => {
        if (e.target.classList.contains('jsAccordionTitle')) {
            e.preventDefault();

            const parent = e.target.parentElement;

            if (!parent.classList.contains('is-active')) {
                this.closeOpenAccordionElements();
                this.openAccordionEl(parent);
            }
            else {
                this.closeAccordionEl(parent);
            }
        }
    });

    this.filtersEl.addEventListener('change', e => {
        // When using radio buttons:
        this.activeChoices = [];
        const filterEls = this.filtersEl.querySelectorAll('input[type=radio]');
        for (let i = 0; i < filterEls.length; i++) {
            const el = filterEls[i];

            if (el.checked) {
                this.activeChoices.push(el.value);
            }
        }

        // When using checkboxes
        // if (e.target.checked) {
        //     if (this.activeChoices.indexOf(e.target.value) === -1) this.activeChoices.push(e.target.value);
        // }
        // else {
        //     const index = this.activeChoices.indexOf(e.target.value);
        //     if (index > -1) this.activeChoices.splice(index, 1);
        // }

        // Process the result
        this.closeOpenAccordionElements();
        this.updateView();
    });

    this.methododsAvailableEl.addEventListener('click', e => {
        e.preventDefault();
        const bounds = this.gridEl.getBoundingClientRect();
        window.scrollTo({top: window.scrollY + bounds.top - 80, behavior: 'smooth'});
    });

    this.setItemCounterVisibility();
    window.addEventListener('scroll', _ => this.setItemCounterVisibility());
}

Anticonceptietool.prototype.closeOpenAccordionElements = function() {
    [...this.el.querySelectorAll('.jsAccordionItem.is-active')].map(item => this.closeAccordionEl(item));
};

Anticonceptietool.prototype.openAccordionEl = function(element) {
    element.classList.add('is-active');
    const newHeight = element.offsetHeight;
    element.classList.remove('is-active');

    gsap.timeline()
        .set(element, { height: element.offsetHeight })
        .add(_ => element.classList.add('is-active'))
        .to(element, 0.25, { height: newHeight, ease: Power2.inOut })
        .set(element, { clearProps: 'all' })
    ;
};

Anticonceptietool.prototype.closeAccordionEl = function(element) {
    element.classList.remove('is-active');
    const newHeight = element.offsetHeight;
    element.classList.add('is-active');

    gsap.timeline()
        .set(element, { height: element.offsetHeight })
        .to(element, 0.25, { height: newHeight, ease: Power2.inOut })
        .add(_ => element.classList.remove('is-active'))
        .set(element, { clearProps: 'all' })
    ;
};

Anticonceptietool.prototype.updateView = function() {
    // Show the correct methods
    const activeMethodEls = this.getActiveMethodElsByFilterOptions(this.activeChoices, true);

    // Update the available choices
    const inputEls = this.el.querySelectorAll('input[type="checkbox"]');

    [...inputEls].map(el => {
        // Set the enabled/disabled state
        const availableMethodEls = el.checked ? activeMethodEls : this.getActiveMethodElsByFilterOptions([...this.activeChoices, el.value], false);

        if (availableMethodEls.length === 0) el.disabled = true;
        else el.disabled = false;
    });

    // Update the accordion item headers
    [...this.el.querySelectorAll('.jsAccordionItem')].map(item => {
        if (item.querySelector('input:checked')) item.classList.add('is-filled');
        else item.classList.remove('is-filled');
    });

    // Set the number of methods available
    this.methododsAvailableEl.querySelector('.number').innerHTML = activeMethodEls.length;

    // Show/hide the 'no items available' text
    if (activeMethodEls.length) this.noItemsEl.style.display = '';
    else this.noItemsEl.style.display = 'block';
};

Anticonceptietool.prototype.getActiveMethodElsByFilterOptions = function(activeOptions, disableWhenUnavailable) {
    // When there are no active filters, all items need to be visible
    if (activeOptions.length === 0) {
        const methodEls = [...this.methodEls];

        if (disableWhenUnavailable) methodEls.forEach(el => el.classList.remove('hidden'));
        return methodEls;
    }

    // Divide the active options array into a list for each filter
    const filters = {};

    activeOptions.forEach(option => {
        const optionSplit = option.split('_');
        if (typeof filters[optionSplit[0]] === 'undefined') filters[optionSplit[0]] = [];
        filters[optionSplit[0]].push(option);
    });

    const filterValues = Object.values(filters);

    // Get the available methods based on the selected filter values
    return [...this.methodEls].filter(el => {
        const elTerms = el.dataset.taxonomies.split(' ');

        // For each filter, if one of the terms is set, we're good. If one filter returns false for all terms, we're not good
        for (let i = 0; i < filterValues.length; i++) {
            let isAvailable = false;

            // For each filter, check if the element has at lease one term (OR)
            for (let j = 0; j < filterValues[i].length; j++) {
                if (elTerms.indexOf(filterValues[i][j]) > -1) {
                    isAvailable = true;
                    break;
                }
            }

            // If one of the filters is unavailable, hide the element (AND)
            if (!isAvailable) {
                if (disableWhenUnavailable) el.classList.add('hidden');
                return false;
            }
        }

        if (disableWhenUnavailable) el.classList.remove('hidden');
        return true;
    });
};

Anticonceptietool.prototype.reset = function() {
    [...this.methodEls].map(el => el.classList.remove('hidden'));

    this.filtersEl.reset();
    this.activeChoices = [];
    this.updateView();
};

Anticonceptietool.prototype.setItemCounterVisibility = function() {
    const bounds = this.gridEl.getBoundingClientRect();

    if ((bounds.top - window.innerHeight) < -(window.innerHeight * 0.5)) this.methododsAvailableEl.classList.add('hidden');
    else this.methododsAvailableEl.classList.remove('hidden');
};

(function() {
    const anticonceptietoolEl = document.querySelector('.jsAnticonceptietool');
    if (anticonceptietoolEl) new Anticonceptietool(anticonceptietoolEl);
})();
